import Layout from './components/Layout';
import { InputTokenForm } from './components/InputTokenForm';
import { SignUpForm } from './components/SignUpForm';
import { AfterRegisterPage } from './components/AfterRegisterPage';
import { NotFound } from '@/components/Pages/Errors/NotFound';
import { useState } from 'react';
import { AlreadyRegisteredPage } from './components/AlreadyRegisterPage';
import { PageSegment } from '..';

export enum PageName {
  SignUp = 'SIGN_UP',
  Token = 'TOKEN',
  AlreadyRegistered = 'ALREADY_REGISTERED',
  AfterRegister = 'AFTER_REGISTER',
  Invalid = 'INVAILD'
}

export function SignUpPage(props: {
  setActivePage: React.Dispatch<React.SetStateAction<PageSegment>>;
  facilityName?: string;
}) {
  const [activePage, setActivePage] = useState(PageName.SignUp);
  const [username, setUsername] = useState<string>('');

  const handleUsernameSet = (username: string) => {
    setUsername(username);
  };

  switch (activePage) {
    case PageName.SignUp:
      return (
        <Layout
          title={props.facilityName || 'お客様情報登録'}
          backButton={true}
          noMyPage={true}
          handleBack={() => props.setActivePage(PageSegment.Top)}
        >
          <SignUpForm setActivePage={setActivePage} onUsernameSet={handleUsernameSet} />
        </Layout>
      );
    case PageName.Token:
      return (
        <Layout title={props.facilityName || 'お客様情報登録'} noMyPage={true}>
          <InputTokenForm setActivePage={setActivePage} username={username} />
        </Layout>
      );
    case PageName.AfterRegister:
      return (
        <Layout title={props.facilityName || 'お客様情報登録'} noMyPage={true}>
          <AfterRegisterPage setActivePage={setActivePage} />
        </Layout>
      );
    case PageName.AlreadyRegistered:
      return (
        <Layout title={props.facilityName || 'お客様情報登録'} noMyPage={true}>
          <AlreadyRegisteredPage setActivePage={setActivePage} />
        </Layout>
      );
    default:
      return <NotFound />;
  }
}

export default SignUpPage;
